import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useFarbwelt } from "@/hooks";
import { AdFooter } from "../Sections/AdFooter";
import { Divider } from "@gemini/ui";
import { AdSlotIds } from "@/shared/types";
import { useShowAds } from "../Ads/hooks/useShowAds";
export const bottomSectionTestId = "cdp-bottom-section";
export const BottomSection = () => {
    const { isFarbweltActive } = useFarbwelt();
    const { showSection } = useShowAds();
    return (_jsxs(_Fragment, { children: [showSection([AdSlotIds.AD_MEDIUM_RECTANGLE_MOBILE]) && (_jsx(Box, { paddingHorizontal: {
                    "breakpoint.base": "spacing.16",
                    "breakpoint.sm": "spacing.32",
                    "breakpoint.lg": "spacing.none",
                }, gridColumn: "col-start / span 4", children: _jsx(Divider, { "aria-hidden": "true" }) })), _jsx(Box, { gridColumn: {
                    "breakpoint.base": "col-start / span 4",
                    "breakpoint.sm": "col-start / span 8",
                    "breakpoint.lg": "col-start / span 4",
                    "breakpoint.xl": "col-start 2 / span 6",
                    "breakpoint.xxxl": "col-start 3 / span 5",
                }, testId: bottomSectionTestId, unsafe_className: "HideOnPrint", height: "min-content", display: showSection([AdSlotIds.AD_MEDIUM_RECTANGLE_MOBILE]) ||
                    isFarbweltActive
                    ? "block"
                    : "none", children: _jsx(AdFooter, {}) })] }));
};
